import React from 'react';
import CourseCard from './components/CourseCard.jsx';
import Header from '../../components/Headers/Header.jsx';
import CartBtn from '../../components/CartBtn/CartBtn.jsx';

export default function CourseAll() {
    return (
        <>
            <div className="p VideoCard  h-100">
                <Header />
                <CourseCard />
                <CartBtn />
            </div>
        </>
    )
}
